module.exports = __webpack_public_path__ + "img/bank-07-ibk.7098cb2b.svg";